// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OqSC","rootMobile":"styles_rootMobile__3Gm5h"};